module.exports = __webpack_public_path__ + "static/media/chu-tablet.22b77b7d.jpg";